<template>
    <div class="listview-title my-2" style="display: flow !important;">
        <div class="row">
            <div class="col-6 align-content-center">
                تعداد تماس رایگان شما : {{ freeCalls }}
            </div>
            <div class="col-6 text-end">
                <button @click="offPardakht" data-bs-toggle="offcanvas" :data-bs-target="'#actionSheetContent_1'"
                    class="btn btn-outline-warning btn-sm btn-block rounded shadowed">رفع محدودیت
                </button>
                <Peyment :driver_id="driver_id" :data="1" />
            </div>
        </div>
    </div>
</template>
<script>
import Peyment from './Peyment.vue';

export default {
    props: ['freeCalls'],

    components: {
        Peyment
    },
    data() {
        return {
            driver_id: window.localStorage.getItem("idUser"),
        }
    },
    methods: {
        offPardakht() {
            localStorage.setItem("offPardakht", 1);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?offPardakht=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
    },
}
</script>
<style></style>